import Vue from 'vue';
import Vuex from 'vuex';
import { getCookie } from '../common/js/v';

Vue.use(Vuex);
let userName;
if(getCookie("mctSign")){
  userName = decodeURI(getCookie('www_user_name',1));
}else{
  // userName = getCookie('www_user_name');
  userName = localStorage.getItem('www_user_name')
}
const state = {
  loadingBol: false,
  userName: userName,
  isLogin: false,
  navShowBol: true,
  isSearchDown: false,
  shopCartNumber: 0,
  cartsNum: 0,
	isInMain:false
};

const mutations = {
  LSHOW(state){
    state.loadingBol = false;
  },
  LHIDE(state){
    state.loadingBol = false;
  },
  setNavShowBol (state, bol) {
    state.navShowBol = bol;
  },
  setSearchDown (state,bol) {
    state.isSearchDown = bol;
  },
  setShopCartNumber (state, num) {
    if (num) {
      state.shopCartNumber += num;
    } else {
      state.shopCartNumber += 1;
    }
  },
  setCartsNum(state, num) {
    console.log(state.cartsNum, num)
    if (num) {
      state.cartsNum += num;
    } else {
      state.cartsNum += 1;
    }
  },
  setUserName (state, str) {
    let userName;
    if(getCookie("mctSign")){
      userName = str?decodeURI(str):'';
    }else{
      userName = str?str:'';
    }
    state.userName = userName;
    if(!str)window.localStorage.removeItem('userMemberInfo');
  }
};

export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/store/store.js